// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`StepNavigator test Match con el snapshot 1`] = `""`;
